const EXPORT = {
  CLOSE_RED: {
    neutral: "/svg/exports/close_red.svg",
  },
  DOWNLOAD: {
    dark: "/svg/exports/download_dark.svg",
  },
  PDF: {
    neutral: "/svg/exports/pdf.svg",
  },
  PNG: {
    neutral: "/svg/exports/png.svg",
  },
  PPT: {
    neutral: "/svg/exports/ppt.svg",
  },
  XLSX: {
    neutral: "/svg/exports/xlsx.svg",
  },
};

export default EXPORT;
